import React from 'react';
import { CardBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import Icon from '../../../common/Icon';

const CheckoutNoShippingAvailable = () => {
  return (
    <CardBody className="CheckoutNoShippingAvailable">
      <div className="CheckoutNoShippingAvailable__content">
        <div className="CheckoutNoShippingAvailable__icon">
          <Icon name="exclamation-triangle" />
        </div>
        <div className="CheckoutNoShippingAvailable__message">
          <div className="CheckoutNoShippingAvailable__title">
            <FormattedMessage
              id="checkout.noShipping.title"
              defaultMessage="No shipping methods available"
            />
          </div>
          <p className="CheckoutNoShippingAvailable__description">
            <FormattedMessage
              id="checkout.noShipping.description"
              defaultMessage="Unfortunately, there are no suitable shipping methods available for your order. Please check your delivery address or contact customer service for assistance."
            />
          </p>
        </div>
      </div>
    </CardBody>
  );
};

export default CheckoutNoShippingAvailable;

